import React from 'react';
import { getBadgeCSSProperties } from '../../config/badgeColors';
import './Badge.scss';

const Badge = ({ title, achievement, onClick, isSelectable = false }) => {
  const className = `badge ${isSelectable ? 'badge--selectable' : ''}`;
  
  // Get color properties if achievement data is provided
  const colorStyles = achievement ? getBadgeCSSProperties(achievement) : {};
  
  // Handle keyboard interaction for accessibility
  const handleKeyDown = (event) => {
    if (!isSelectable || !onClick) return;
    
    // Trigger click on Enter or Space key
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick(event);
    }
  };
  
  return (
    <div 
      className={className}
      style={colorStyles}
      onClick={isSelectable ? onClick : undefined}
      onKeyDown={isSelectable ? handleKeyDown : undefined}
      role={isSelectable ? 'button' : undefined}
      tabIndex={isSelectable ? 0 : undefined}
    >
      <span className="badge__text">{title}</span>
    </div>
  );
};

export default Badge;